import { TsDOM as q } from '@/scripts/core/TsDOM'
import { MainSearch } from '@/scripts/catalog/main-search'
import { DynamicCollection } from '@/scripts/catalog/dynamic-collection'
import { FilterForm } from '@/scripts/catalog/filter-form'
import { FilterDrawer } from '@/scripts/catalog/filter-drawer'
import { FacetRemove } from '@/scripts/catalog/facet-remove'
import { PriceRange } from '@/scripts/catalog/price-range'

q.safeDefineElement(MainSearch)
q.safeDefineElement(DynamicCollection)
q.safeDefineElement(FilterForm)
q.safeDefineElement(FilterDrawer)
q.safeDefineElement(FacetRemove)
q.safeDefineElement(PriceRange)
